module.exports = __webpack_public_path__ + "static/musicCares-419a6ff689dfbb61bf6a0bcc7068c746.png";